import { axiosCall } from "../apiCall";
import { SERVER_METHODS } from "../../config/enums";
import { stringFormat, formatDate } from "../../global/helpers";
import PATHS from "../../../../json/paths.json";
import store from "../../../../redux/store";
import { templateTypeID, usesGenericDefinition, hidesPricing, withoutPricing } from "../../config/templateTypes";

const { REACT_APP_webneurolageAPI } = process.env;

export function GetSchema() {
  const state = store.getState();
  const templateType = state.current.selectedTemplateType;
  if (usesGenericDefinition(templateType)) {
    const path = REACT_APP_webneurolageAPI + stringFormat(PATHS.GetGenericSchema, { pos: state.current.selectedPOS });
    return axiosCall(SERVER_METHODS.POST, path, {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    }, { TemplateTypeID: templateTypeID(templateType) }, false);
  }
  const data = {
    pos: state.current.selectedPOS,
    template: state.current.selectedTemplateType,
    orgid: state.global.configuration.orgID,
  };
  var path = REACT_APP_webneurolageAPI + stringFormat(PATHS.GetSchema, data);
  const request = axiosCall(SERVER_METHODS.GET, path, {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }, {}, false);
  // Collection notes use the invoice definitions without the pricing fields.
  if (!hidesPricing(templateType)) return request;
  return request.then((response) => (response?.isSuccess && response.data?.Result
    ? { ...response, data: { ...response.data, Result: withoutPricing(response.data.Result) } }
    : response));
}

// `htmlBands`: { [band id]: URI-encoded HTML } for a bands-format template
// (docs/bands-spec.md §10), or null for the four-section format.
export function SaveTemplate(htmlData, htmlHeaderData, htmlFooterData, htmlTotalData, htmlBands = null) {
  const state = store.getState();
  var template = state.template;
  var selectedTemplate = state.current.selectedTemplate;
  return SaveTemplateData(template,htmlData, htmlHeaderData, htmlFooterData, htmlTotalData,selectedTemplate, htmlBands);
}

// `htmlBands` undefined keeps the band HTML the template already has (e.g.
// when only its default flag changes); null removes it.
//
// The template store keeps HTMLData as text values only (a Go
// map[string]string), so the band HTML is sent as one JSON string:
// HTMLData.Bands = '{"head":"<URI-encoded HTML>", …}'.
export function SaveTemplateData(template, htmlData, htmlHeaderData, htmlFooterData, htmlTotalData, selectedTemplate = null, htmlBands = undefined) {
  const state = store.getState();
  let date = JSON.parse(JSON.stringify(new Date()));
  let userID = state.global.currentUser.userID;
  let CloudUserID = state.global.cloudUser.userID;

  var data = {};
  if (selectedTemplate === null || !selectedTemplate)
    data = {
      orgID: sessionStorage.getItem('orgID'),
    cloudLocationID: sessionStorage.getItem('LocationID'),
      //: 1,
      Description: "",
      CreatedDate: date,
      CreatedBy: userID,
      IsDefault: false,
      IsDeleted: false,
      CloudCreatedBy: CloudUserID,
      CloudModifiedBy: CloudUserID,
    };
  else data = selectedTemplate;

  var TemplateTypeID = templateTypeID(state.current.selectedTemplateType);

  // A saved template already holds the string; anything else is encoded here.
  const savedBands = htmlBands === undefined ? selectedTemplate?.HTMLData?.Bands : htmlBands;
  const bands = savedBands && typeof savedBands !== "string" ? JSON.stringify(savedBands) : savedBands;

  data = {
    ...data,
    TemplateName: template.prop.templateName,
    TemplateData: JSON.stringify(template),
    ModifiedBy: userID,
    ModifiedDate: date,
    //(Invoice - 1, ProformaInvoice - 2, DeliveryNote - 3, PurchaseOrder - 4)
    TemplateTypeID: TemplateTypeID,
    HTMLData: {
      HTMLString: htmlData,
      HTMLHeaderSrting: htmlHeaderData,
      HTMLFooterString: htmlFooterData,
      HTMLTotalString: htmlTotalData,
      ...(bands ? { Bands: bands } : {})
    }
  };
  //-- v1/{pos}/{template}/add
  var path =
    REACT_APP_webneurolageAPI +
    stringFormat(selectedTemplate ? PATHS.UpdateTemplate : PATHS.SaveTemplate, {
      pos: state.current.selectedPOS,
      template: state.current.selectedTemplateType,
    });

  console.log(data);
  return axiosCall(SERVER_METHODS.POST, path, {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }, data, false);
}

export function DeleteTemplate(template) {
  const state = store.getState();
  var selectedTemplate = state.current.selectedTemplate;
  var path =
    REACT_APP_webneurolageAPI +
    stringFormat( PATHS.UpdateTemplate, {
      pos: state.current.selectedPOS,
      template: state.current.selectedTemplateType,
    });

  return axiosCall(SERVER_METHODS.POST, path, {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }, template, false);
}

export function GetAllTemplates() {
  const state = store.getState();

  var data = {
    orgID: sessionStorage.getItem('orgID'),
    cloudLocationID: sessionStorage.getItem('LocationID'),
  };

  //-- v1/{pos}/{template}/fetch

  var path =
    REACT_APP_webneurolageAPI +
    stringFormat(PATHS.FetchTemplates, {
      pos: state.current.selectedPOS,
      template: state.current.selectedTemplateType,
    });

  path = path + templateTypeID(state.current.selectedTemplateType);

  return axiosCall(SERVER_METHODS.POST, path, {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }, data, false);
}

export async function SetDefault(templates, defaultTemplate) {
  //console.log(templates);
  templates.forEach((t) => {
    console.log(t);
    var data = t.TemplateData;
    // let htmlString=t.HTMLData.HTMLString || ""
    try {
      data = JSON.parse(data);
      SaveTemplateData(data, t.HTMLData.HTMLString, t.HTMLData.HTMLHeaderSrting, t.HTMLData.HTMLFooterString, t.HTMLData.HTMLTotalString , t);
    } catch (error) {
      //data = [];
    }
  });
  return SaveTemplateData(
    JSON.parse(defaultTemplate.TemplateData),
    defaultTemplate.HTMLData.HTMLString || "",
    defaultTemplate.HTMLData.HTMLHeaderSrting || "",
    defaultTemplate.HTMLData.HTMLFooterString || "",
    defaultTemplate.HTMLData.HTMLTotalString || "",
    defaultTemplate
  );
}
